/* eslint-disable import/prefer-default-export */
export gender from './loan/gender';
export loansArray from './loan/loansArray';
export maritalStatuses from './loan/martialStatuses';
export educationTypes from './loan/educationTypes';
export employmentDurationTypes from './loan/employmentDurationTypes';
export jobTypes from './loan/jobTypes';
export occupationSector from './loan/occupationSector';
export industryTypes from './loan/industryTypes';
export provinces from './loan/provinces.es';
export childrens from './loan/childrens';
export genders from './loan/gender';
export banksList from './loan/banksList';
export bankAccountDuration from './loan/bankAccountDuration';
export bankAccountTypesMX from './loan/bankAccountTypesMX';
export bankLoginLinks from './loan/bankLoginLinks';
export incomeFrequency from './loan/incomeFrequency';
export frequencyPeriods from './loan/frequencyPeriods';
export loanPaymentsFrequency from './loan/loanPaymentsFrequency';
export inputRangeClassNames from './styles/inputRangeClassNames';
export loanPurpose from './loan/loanPurpose';
export learnedAboutUsFromType from './loan/learnedAboutUsFromType';
export authButtonTypesSignUpEE from './loan/authButtonTypesSignUpEE';
export authButtonTypesLoginEE from './loan/authButtonTypesLoginEE';
export statesAU from './loan/states.au';
export repaymentItems from './loan/repaymentItems';
export maturityPeriods from './selfservice/maturityPeriods';
export relationshipOptions from './loan/relationshipOptions';
export possiblePeriodsCL from './loan/possiblePeriodsCL';
export retirementTypes from './loan/retirementTypes';
export universitiesMX from './loan/universitiesMX';
export freelanceIndustriesMX from './loan/freelanceIndustriesMX';
export finpassToAioBanksLT from './loan/finpassToAioBanksLT';
export { eidErrorsToCount, eidVerificationAppReviewErrors } from './loan/eidErrors';
export fieldsNeededForPutCustomerInfoES from './loan/fieldsNeededForPutCustomerInfoES';
export EsLoanAmountList from './loan/loanAmounts';
export savingTablePeriods from './loan/savingTablePeriods';
export residenceDocumentTypes from './loan/residenceDocumentTypes';
export * from './loan/visaTypes';
export * from './loan/medicareCardType';
export * from './loan/identDocumentTypes';
export * from './loan/residenceTypes';
export * from './loan/workingStateTypes';
export const MAX_FILE_SIZE_IN_MB = 5;
export const MAX_FILE_COUNT = 20;
export const MAX_FILE_SIZE_IN_MB_ES = 10;
export const MAX_FILE_SIZE_IN_MB_CZ = 10;
export const MAX_FILE_SIZE_TOTAL_IN_MB_CZ = 30;
export const MAX_FILE_COUNT_ES = 1;
export const SMART_ID_ERROR = 'smartId.errorType';
export const financialDataValidationErrors = {
  IDENTIFIER_AS_CUSTOMER: {
    field: 'spouseIdentifier',
    errorMessage: 'errors.field.sameSsn',
  },
  MSISDN_AS_CUSTOMER: {
    field: 'spouseMsisdn',
    errorMessage: 'errors.field.spouseMsisdn',
  },
  NOT_MARRIED: {
    field: 'spouseIdentifier',
    errorMessage: 'errors.field.notMarried',
  },
};
export const PROVISO_MOCK_URL = 'https://apitest.bankfeeds.com.au/MOCK';
